import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const materialsApi = {
  list: (search) => client.get("/materials", { params: search ? { search } : {} }).then((r) => r.data),
  create: (data) => client.post("/materials", data).then((r) => r.data),
  update: (id, data) => client.put(`/materials/${id}`, data).then((r) => r.data),
  remove: (id) => client.delete(`/materials/${id}`).then((r) => r.data),
};

export const apiKeyApi = {
  get: () => client.get("/settings/api-key").then((r) => r.data),
  rotate: () => client.post("/settings/api-key/rotate").then((r) => r.data),
};

export const salesPricesApi = {
  list: (search) => client.get("/sales-prices", { params: search ? { search } : {} }).then((r) => r.data),
  create: (data) => client.post("/sales-prices", data).then((r) => r.data),
  update: (id, data) => client.put(`/sales-prices/${id}`, data).then((r) => r.data),
  remove: (id) => client.delete(`/sales-prices/${id}`).then((r) => r.data),
};

export const tasksApi = {
  list: (params) => client.get("/tasks", { params: params || {} }).then((r) => r.data),
  get: (id) => client.get(`/tasks/${id}`).then((r) => r.data),
  create: (data) => client.post("/tasks", data).then((r) => r.data),
  update: (id, data) => client.put(`/tasks/${id}`, data).then((r) => r.data),
  setStatus: (id, status) => client.patch(`/tasks/${id}/status`, { status }).then((r) => r.data),
  remove: (id) => client.delete(`/tasks/${id}`).then((r) => r.data),
  addComment: (id, text) => client.post(`/tasks/${id}/comments`, { text }).then((r) => r.data),
  removeComment: (id, cid) => client.delete(`/tasks/${id}/comments/${cid}`).then((r) => r.data),
  users: () => client.get("/task-users").then((r) => r.data),
  uploadAttachment: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post(`/tasks/${id}/attachments`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  attachmentUrl: (id, fid) => `${API}/tasks/${id}/attachments/${fid}/download`,
};

export const notificationsApi = {
  list: () => client.get("/notifications").then((r) => r.data),
  read: (id) => client.post(`/notifications/${id}/read`).then((r) => r.data),
  readAll: () => client.post("/notifications/read-all").then((r) => r.data),
};

export const usersApi = {
  list: () => client.get("/authorized-users").then((r) => r.data),
  add: (email, role, name) => client.post("/authorized-users", { email, role, name: name || "" }).then((r) => r.data),
  remove: (id) => client.delete(`/authorized-users/${encodeURIComponent(id)}`).then((r) => r.data),
};

export const projectsApi = {
  list: () => client.get("/projects").then((r) => r.data),
  get: (id) => client.get(`/projects/${id}`).then((r) => r.data),
  create: (data) => client.post("/projects", data).then((r) => r.data),
  update: (id, data) => client.put(`/projects/${id}`, data).then((r) => r.data),
  remove: (id) => client.delete(`/projects/${id}`).then((r) => r.data),
  group: (ids, variantGroup, groupName) => client.post("/projects/group", { project_ids: ids, variant_group: variantGroup || null, group_name: groupName ?? null }).then((r) => r.data),
  setVisibility: (id, visible) => client.patch(`/projects/${id}/visibility`, { visible }).then((r) => r.data),
  exportUrl: (id, kind) => `${API}/projects/${id}/export${kind ? `?kind=${kind}` : ""}`,
  groupExportUrl: (variantGroup, kdv, kind) => `${API}/projects/group/${variantGroup}/export?kdv=${kdv ?? 20}${kind ? `&kind=${kind}` : ""}`,
  extractImage: (files) => {
    const fd = new FormData();
    (Array.isArray(files) ? files : [files]).forEach((f) => fd.append("files", f));
    return client.post("/structural/extract-image", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};
